var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconStande20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#FBFBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 14.0492C22.9999 14.0328 23 14.0164 23 14C23 10.6863 20.3137 8 17 8C13.6863 8 11 10.6863 11 14L10.9998 14.75C10.9998 17.0656 10.1253 19.177 8.68848 20.7719C10.4214 21.4116 12.2484 21.857 14.1431 22.0818C15.0799 22.1929 16.0332 22.25 16.9998 22.25C17.9666 22.25 18.92 22.1928 19.8568 22.0817C21.7514 21.857 23.5783 21.4116 25.3111 20.7719C23.8743 19.177 22.9998 17.0656 22.9998 14.75V14.0492Z",
    fill: "#343634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8569 22.0817C21.7514 21.857 23.5783 21.4116 25.3111 20.7719C23.8743 19.177 22.9998 17.0656 22.9998 14.75V14.0492C22.9999 14.0328 23 14.0164 23 14C23 10.6863 20.3137 8 17 8C13.6863 8 11 10.6863 11 14L10.9998 14.75C10.9998 17.0656 10.1253 19.177 8.68848 20.7719C10.4214 21.4116 12.2484 21.857 14.1431 22.0818M19.8569 22.0817C18.92 22.1928 17.9666 22.25 16.9998 22.25C16.0332 22.25 15.0799 22.1929 14.1431 22.0818M19.8569 22.0817C19.9498 22.3711 20 22.6797 20 23C20 24.6569 18.6569 26 17 26C15.3431 26 14 24.6569 14 23C14 22.6797 14.0502 22.3712 14.1431 22.0818",
    stroke: "#1E1E1E",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconStande20);
export default __webpack_public_path__ + "static/media/Notification-Icon-Stande2.0.48ad2f5a7bdd597a37f5ef33a0d1afdc.svg";
export { ForwardRef as ReactComponent };